import { CloudbaseEventEmitter } from './events'

export const bus = new CloudbaseEventEmitter()

export const LANG_CHANGE_EVENT = 'lang_change'
